{
  "en": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Change Logo (png required)",
        "changeThemeColor": "Pick a new theme color"
      },
      "errors": {
        "themeColorInvalid": "Enter six characters, 0-9 or A-F. For example 096553."
      },
      "labels": {
        "customerThemeColor": "Customer theme color",
        "customerThemeColorExlainer": "This color will be used for the customer portal. Impersonate a customer to see this in action.",
        "logo": "Logo"
      },
      "paused": {
        "description": "Your account at {client} still exists, but your access is switched off right now, so the platform stays closed. An owner of your organization can turn your access back on.",
        "noAccess": "No access",
        "open": "Open",
        "title": "Your access is paused",
        "yourOrganizations": "Your organizations"
      },
      "picture_logo_format": {
        "round": "Round Logo",
        "square": "Square Logo"
      }
    }
  }
}
